import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

const MESSAGES = {
  credential_missing: "No storage credential is configured on this server.",
  credential_invalid: "The storage credential is not a valid base64 service-account key.",
  authentication_failed: "Google rejected the storage credential.",
  permission_denied: "The service account is not allowed to do this on the bucket.",
  bucket_or_object_not_found: "Bucket or test object not found.",
  object_already_exists: "A test object with that name already exists (nothing overwritten).",
  checksum_mismatch: "Read-back bytes did not match what was uploaded.",
  timeout: "The storage service did not respond in time.",
  test_already_running: "A test is already running. Try again in a moment.",
  storage_error: "Storage request failed.",
};

export const ArchiveConnectivityTest = () => {
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const run = async () => {
    setBusy(true);
    setRes(null);
    try {
      const { data } = await api.post("/admin/archive/connectivity-test");
      setRes(data);
    } catch (e) {
      setRes({ ok: false, error: e?.response?.status === 403 ? "forbidden" : "request_failed" });
    } finally {
      setBusy(false);
    }
  };
  return (
    <section data-testid="archive-test-card" className="mt-8 rounded-xl border border-stone-200 bg-white p-5">
      <h2 className="font-editorial text-xl">Evidence archive storage</h2>
      <p className="mt-1 text-sm text-stone-600">Uploads one small new test file to the private bucket, reads it back and compares SHA-256 checksums. Nothing is overwritten or deleted.</p>
      <Button data-testid="archive-test-btn" className="mt-3" onClick={run} disabled={busy}>
        {busy ? "Testing…" : "Test storage connection"}
      </Button>
      {res && (
        <div data-testid="archive-test-result" className={`mt-3 text-sm ${res.ok ? "text-emerald-800" : "text-red-700"}`}>
          <p data-testid="archive-test-status" className="font-medium">{res.ok ? "Success: upload and read-back matched." : `Failed: ${MESSAGES[res.error] || res.error}`}</p>
          {res.object_path && <p className="mt-1 break-all font-mono text-xs" data-testid="archive-test-object">{res.bucket}/{res.object_path}</p>}
          {res.sha256_uploaded && <p className="mt-1 break-all font-mono text-xs text-stone-600" data-testid="archive-test-sha">uploaded {res.sha256_uploaded}<br />read back {res.sha256_read_back || "–"}</p>}
        </div>
      )}
    </section>
  );
};
